module.exports = __webpack_public_path__ + "img/invoice.21c319a7.svg";